import React, { useContext, useState } from 'react'
import { AuthContext } from '../../contexts/AuthContext'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import Loader from '../../components/Loader'
import axiosInstance from '../../utils/api'

type Props = {}

const Login = (props: Props) => {
    
    const { login }= useContext(AuthContext)
    let navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [inputs, setInputs] = useState({
        username: "",
        password: ""
    })

    function handleInput(e:React.ChangeEvent<HTMLInputElement>, field:string) {
        setInputs({
            ...inputs,
            [field]: e.target.value
        })
    }
    
    function submit(e: React.FormEvent) {
        e.preventDefault()
        setLoading(true)
        axios.post(`https://api.cl-ds.com/token/`, inputs).then(res => {
            setLoading(false)
            console.log(res.data)

            if (!res.data.role) {
                return alert("Not Authorised")
            }
            localStorage.setItem('access_token', res.data.access)
            localStorage.setItem('refresh_token', res.data.refresh)
            // alert('Login Successfully')
            res.data["username"] = inputs.username
            login(res.data)
            return window.location.href = "/"
        }).catch(err=>{ 
            setLoading(false)
            console.log(err.response.data)
            alert(err.response.data.detail)
            
        })
    }

    return (
        <div className="container">
        {loading && ( <Loader/> )}

        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
            <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                <div className="d-flex justify-content-center py-4">
                    <a href="/" className="logo d-flex align-items-center w-auto">
                    <img src="assets/img/logo.png" alt=""/>
                    <span className="d-none d-lg-block">Cloudatik</span>
                    </a>
                </div>

                <div className="card mb-3">

                    <div className="card-body">

                    <div className="pt-4 pb-2">
                        <h5 className="card-title text-center pb-0 fs-4">Login to Your Account</h5>
                        <p className="text-center small">Enter your username & password to login</p>
                    </div>

                    <form className="row g-3 needs-validation">

                        <div className="col-12">
                        <label className="form-label">Username</label>
                        <div className="input-group has-validation">
                            <input type="text" name="username" className="form-control" onChange={(e)=>handleInput(e, 'username')}/>
                            <div className="invalid-feedback">Please enter your username.</div>
                        </div>
                        </div>

                        <div className="col-12">
                        <label className="form-label">Password</label>
                        <input type="password" name="password" className="form-control" onChange={(e)=>handleInput(e, 'password')}/>
                        <div className="invalid-feedback">Please enter your password!</div>
                        </div>

                        {/* <div className="col-12">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" name="remember" value="true" id="rememberMe"/>
                            <label className="form-check-label">Remember me</label>
                        </div>
                        </div> */}
                        <div className="col-12">
                        <button className="btn btn-primary w-100" type="submit" onClick={(e)=>{submit(e)}}>Login</button>
                        </div>
                        {/* <div className="col-12">
                        <p className="small mb-0">Don't have account? <a href="pages-register.html">Create an account</a></p>
                        </div> */}
                    </form>

                    </div>
                </div>

                </div>
            </div>
            </div>

        </section>

        </div>
    )
}

export default Login